import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section-padding" }
const _hoisted_2 = { class: "d-none d-md-flex" }
const _hoisted_3 = { class: "column" }
const _hoisted_4 = { class: "column second" }
const _hoisted_5 = { class: "d-flex flex-column d-md-none" }
const _hoisted_6 = { class: "text-just" }
const _hoisted_7 = { class: "text-just" }

import LogoImageBackground from "@/components/LogoImageBackground.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'AboutMeView',
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('sectionAboutMe.aboutMe')), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h5", null, _toDisplayString(_ctx.$t('sectionAboutMe.slogen')), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", null, _toDisplayString(_ctx.$t('sectionAboutMe.aboutMeText')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h6", null, _toDisplayString(_ctx.$t('sectionAboutMe.slogen')), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h6", null, _toDisplayString(_ctx.$t('sectionAboutMe.aboutMeText')), 1)
        ])
      ])
    ]),
    _createVNode(LogoImageBackground)
  ], 64))
}
}

})